var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9827 5.15945L12.8412 2.01719C12.7367 1.91269 12.6127 1.8298 12.4762 1.77325C12.3397 1.7167 12.1933 1.68759 12.0456 1.68759C11.8978 1.68759 11.7515 1.7167 11.615 1.77325C11.4785 1.8298 11.3545 1.91269 11.25 2.01719L2.57977 10.6881C2.47485 10.7922 2.39167 10.9161 2.33506 11.0526C2.27844 11.1892 2.24953 11.3356 2.25001 11.4834V14.6256C2.25001 14.924 2.36853 15.2101 2.57951 15.4211C2.79049 15.6321 3.07664 15.7506 3.37501 15.7506H6.51727C6.66506 15.7511 6.81147 15.7222 6.94799 15.6656C7.08451 15.609 7.20842 15.5258 7.31251 15.4209L15.9827 6.75062C16.0872 6.64616 16.1701 6.52212 16.2267 6.38562C16.2832 6.24911 16.3123 6.1028 16.3123 5.95504C16.3123 5.80728 16.2832 5.66097 16.2267 5.52446C16.1701 5.38795 16.0872 5.26392 15.9827 5.15945ZM6.51727 14.6256H3.37501V11.4834L9.56251 5.29586L12.7048 8.43812L6.51727 14.6256ZM13.5 7.64219L10.3577 4.50062L12.0452 2.81312L15.1875 5.95469L13.5 7.64219Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2db9ad1617e57961b5d8e44ff5da1fe3.svg";
export { ForwardRef as ReactComponent };